module.exports = "/lucky-balls/img/drawnballs/black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/black.png
// module id = 1008
// module chunks = 0